import styled from 'styled-components';
import { Typography } from '@mui/material';

interface StepperProps {
    activeStep: any;
    completed: boolean;
}

const Stepper = (props) => {
    const { steps, activeStep } = props;

    return (
        <Container>
            {steps.map((o, index) => {
                return (
                    <StepBar key={index} activeStep={activeStep === index} completed={activeStep > index}>
                        <StepBarTitle>
                            0{index + 1} {o.label}
                        </StepBarTitle>
                        <StepBarDetails variant="body2">{o.data}</StepBarDetails>
                        <div />
                    </StepBar>
                );
            })}
        </Container>
    );
};

export default Stepper;

const Container = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: center;
    margin: 20px 0px;
`;

const StepBar = styled.div<StepperProps>`
    /* width: 85%; */
    flex: 1;
    div {
        min-height: 7px;
        margin-right: 10px;
        border: ${(props) => (props.activeStep ? null : '1px solid rgba(0, 124, 222, 0.5)')};
        background-color: ${(props) => (props.activeStep ? 'rgba(0, 124, 222, 0.5)' : props.completed ? '#007cde' : 'transparent')};
    }
`;

const StepBarTitle = styled(Typography)`
    && {
        font-size: 12px;
        color: #007cde;
        font-weight: 800;
    }
`;

const StepBarDetails = styled(Typography)`
    && {
        margin-bottom: 0px;
        text-transform: capitalize;
        min-height: 20px;
    }
`;
